export class CreatePbaErrorResponse {
  name: any;
  method: any;
}
